import React from 'react'
import { Box, Paper, styled, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { IDropdownDto } from 'src/generated-types/api-result'
import { AppTextField } from '../AppTextField'

export interface ISchemaSelectionSectionProps {
  formSchema?: IDropdownDto
}

export const SchemaSelectionSection: React.FC<ISchemaSelectionSectionProps> = ({ formSchema }) => {
  const { t: translate } = useTranslation(['dynamic-report'])

  const schemaName = React.useMemo(() => {
    if (!formSchema) return ''
    return formSchema.name ?? ''
  }, [formSchema])

  return (
    <SchemaContainer>
      <SchemaHeader>
        <SectionTitle>{translate('schema-selection', { ns: 'dynamic-report' })}</SectionTitle>
        <SectionSubtitle>{translate('schema-selection-subtitle', { ns: 'dynamic-report' })}</SectionSubtitle>
      </SchemaHeader>
      <SchemaContent>
        <AppTextField
          label={translate('form-schema', { ns: 'dynamic-report' })}
          value={schemaName}
          InputProps={{ readOnly: true }}
          fullWidth
        />
      </SchemaContent>
    </SchemaContainer>
  )
}

const SchemaContainer = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.paper,
  boxShadow: 'none',
  flexShrink: 0,
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderRadius: '0px !important',
}))

const SchemaHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5, 2, 0.5),
  backgroundColor: theme.palette.grey[50],
}))

export const SectionTitle = styled(Typography)(({ theme }) => ({
  margin: 0,
  fontSize: '16px',
  fontWeight: 700,
  color: theme.palette.text.primary,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
}))

export const SectionSubtitle = styled('p')(({ theme }) => ({
  margin: theme.spacing(0.5, 0, 0),
  fontSize: '14px',
  color: theme.palette.text.secondary,
  fontWeight: 400,
}))

const SchemaContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 0.5),
  backgroundColor: theme.palette.grey[50],
}))
